import exercisesApi from 'api/rest/exercises/exercises';
import { resolveSubjectNumericId } from 'services/common/subjectParsers/subjectParsers';
import logError from 'utils/logError/logError';

import useSubjectStore from '../subject';

const getSheetsList = async curriculum => {
  const { subject } = useSubjectStore.getState();
  const subjectId = resolveSubjectNumericId(subject);
  const curriculumList = Array.isArray(curriculum) ? curriculum.filter(Boolean) : [curriculum].filter(Boolean);

  if (!subjectId || !curriculumList.length) {
    return null;
  }

  try {
    return await exercisesApi.getSheetsCatalog({ subject: subjectId, curriculum: curriculumList })();
  } catch (error) {
    logError(error);
    return null;
  }
};

export default getSheetsList;
